'use client';

import { CacheKeys, ServerActionName } from '@headless-workspace/config';
import { ContentAssetKeys, ResultEmpty, ResultFailure, ResultSuccess } from '@headless-workspace/core-domain';
import { getContentAssetServerAction } from '../../../server';
import { useSafeSWR } from '../hooks';
import { useClientData } from '../providers';

export const useDTSLegalMentionsAssets = () => {
    const { getContentAssets } = useClientData();
    const contentAsset = getContentAssets(ContentAssetKeys.DTSLegalMentions);

    const { data, isLoading, error } = useSafeSWR(
        contentAsset ? null : [CacheKeys.ContentAsset, ContentAssetKeys.DTSLegalMentions],
        ServerActionName.getContentAssetServerAction,
        () => getContentAssetServerAction([ContentAssetKeys.DTSLegalMentions]),
    );

    if (contentAsset) {
        return {
            isLoading: false,
            result: ResultSuccess(contentAsset),
        };
    }

    if (!data) {
        if (error) {
            return {
                isLoading,
                result: ResultFailure('error', error instanceof Error ? error.message : ''),
            };
        }

        return { isLoading, result: ResultEmpty() };
    }

    if (data.type === 'empty' || data.data.length === 0) {
        return { isLoading, result: ResultEmpty() };
    }

    return { isLoading, result: ResultSuccess(data.data[0]) };
};
